import React from 'react'
import {Grid, Col, Row} from 'react-bootstrap'

export default (props) => {
  const {main, aside, hero} = props
  return (
    <Grid>
      <Row>
        <Col>
          {hero}
        </Col>
        <Col md={2}>
          {aside}
        </Col>
        <Col md={10}>
          {main}
        </Col>
      </Row>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/Basic.jsx